
import { Config } from 'src/environments/config';

const basePath = Config.baseUrl;

// tslint:disable-next-line: one-variable-per-declaration
export const
    BasePath = basePath,
    AuthUrls = {
        login: `${basePath}/backoffice/login`,
        refreshTokens: `${basePath}/backoffice/refresh-token`,
        refreshCustomToken: `${basePath}/backoffice/refresh-custom-token`,
        forgetPassword: `${basePath}/backoffice/forgot/password`,
        resetPassword: `${basePath}/backoffice/confirm/password`,
        changePassword: `${basePath}/backoffice/change/password`,
        verifyOTP: `${basePath}/backoffice/login/verify-otp`,
        resendOTP: `${basePath}/backoffice/login/resend-otp`,
        logout:  `${basePath}/backoffice/logout`,
        tokenValidate:  `${basePath}/backoffice/validate/token`

    },
    AdminUserUrls = {
        user: `${basePath}/backoffice/`,
        userList: `user/report`,
        createUser: `create-user`,
        editUser: `user/update`,
        deleteUser: `user/delete`,
    },
    MerchantUrls = {
        merchant: `${basePath}/merchant`,
        list: `/list`,
        createMerchant: `/create`,
        editMerchant: `edit-merchant`,
        uploadImage: `/image/upload`,
        downloadImage: `/image/download/`,
        downloadAttachments: `/attachment/download/`
    },
    LocationUrls = {
        location: `${basePath}/backoffice/location`,
        list: `/list`,
        createLocation: `/create`,
    },
    TerminalUrls = {
        terminal: `${basePath}/backoffice/terminal`,
        list: `/list`,
        createTerminal: `/create`,
    },
    TransactionUrls = {
        transaction: `${basePath}/transaction/list`
    },
    FaqUrls = {
        faq: `${basePath}/backoffice/faq`,
        list: `/list`,
        createFaq: `/create`,
    },

    MerchantSettlementUrls = {
        merchantSettlementCalculation: `${basePath}/merchant/settlement/calculate`,
        transactionsForSettlement: `${basePath}/merchant/transaction/list`,
        settlement: `${basePath}/transaction/merchant/settlement`,
        demandSettlement: `${basePath}/merchant/settlement`,
        settlementDocument: `${basePath}/merchant/settlement/list`,
        completePaymentForSettlementDocuments: `${basePath}/transaction/merchant/settlement-documents/complete-payment`,
        downloadSettlements: `${basePath}/transaction/merchant/settlements/transactions`,
        refundTrasaction: `${basePath}/merchant/refund`,
        completePayment: `${basePath}/merchant/settlement/update`,
        repost: `${basePath}/merchant/settlement/repost`,
        repostForCanada: `${basePath}/merchant/settlement/repost/canada`,
        dailySummary: `${basePath}/merchant/report/dailysummary`,
        merchantSettlementSummary: `${basePath}/merchant/merchant-settlement/summary`,
        runMerchantSettlement : `${basePath}/merchant/settlement/create`,
        list: `${basePath}/setting/list`    

    },

    CommentsUrls = {
        commentsCreate: `${basePath}/comment/create`,
        commentsList: `${basePath}/comment/list`,
        commentsUpdateOrDelete: `${basePath}/comment/`,
    },
    ProductUrls = {
        list :`${basePath}/backoffice/merchant/product/list`,
        create:`${basePath}//backoffice/merchant/product/create`,
        edit:`${basePath}/backoffice/merchant/product/`,
        delete:`${basePath}/backoffice/merchant/product/`,
        deleteImage:`${basePath}/backoffice/image/delete/`,
        upload:`${basePath}/backoffice/image/upload`,
        listImages:`${basePath}/backoffice/merchant/product/images/list`,
        downloadImage:`${basePath}/backoffice/image/download/`,
        locationProductlist:`${basePath}/backoffice/merchant/location/product/list`,
        locationBasedProductlist:`${basePath}/backoffice/merchant/location/product/report`,
        createMerchantLocationProduct:`${basePath}/backoffice/merchant/location/product/create`,
        merchantLocationProductsUpdate: `${basePath}/backoffice/merchant/location/product`,
        deleteMerchantProductLocation: `${basePath}/backoffice/merchant/location/product`,
        createLocationProduct: `${basePath}/backoffice/merchant/location/product/create`,
        merchantOffersList: `${basePath}/backoffice/merchant/location/product/offer/list`,
        saveOffers: `${basePath}/backoffice/merchant/location/product/offer/create`,
        updateOffers: `${basePath}/backoffice/merchant/location/product/offer/`,
        deleteOffers: `${basePath}/backoffice/merchant/location/product/offer/`,
        productList: `${basePath}/backoffice/merchant/product/list`,
        productUpdate: `${basePath}/backoffice/merchant/product/`,
        productDelete: `${basePath}/backoffice/merchant/product/`,
        productCreate: `${basePath}/backoffice/merchant/product/create`,
        categoryList:`${basePath}/backoffice/merchant/product/category/list`,
        linkMerchantProductToCategory:`${basePath}/backoffice/merchant/product/category/create`,
        updatelinkMerchantProductToCategory:`${basePath}/backoffice/merchant/product/category/update`,
        deletelinkMerchantProductToCategory:`${basePath}/backoffice/merchant/product/category/`,
        syncProductList: `${basePath}/billpayment/product/sync`,
        checkAyopopBalance: `${basePath}/billpayment/ayopop/balance`,
        merchantLocationProductsList: `${basePath}/backoffice/merchant/location/product/list`,
        productNtLinkedLocation: `${basePath}/backoffice/merchant/product/location/list`,
        thumbnailUpload: `${basePath}/backoffice/image/upload/`,
        thumbnailDownload: `${basePath}/backoffice/image/download/`,
        thumbnailDelete:`${basePath}/backoffice/image/delete/`,
        

    },
     // System 
     systemUrls = {
        list: `${basePath}/setting/list`,
     },
    AttachmentUrls = {
        uploadAttachments: `${basePath}/attachment/create/`,
        downloadAttachments: `${basePath}/attachment/download/`,
        deleteAttachments: `${basePath}/attachment/`,
        listAttachments: `${basePath}/attachment/list`,
    },
    PaymentUrls ={
     generateLink:`${basePath}/merchant/location/payment/initialize`,
     paymentLink:`${basePath}/merchant/location/payment/send-link`,
     requestedPayment:`${basePath}/merchant/location/payment/list`,
     },
    OrdersUrls = {
        listCart: `${basePath}/backoffice/merchant/cart/list`,
        allProductlist:`${basePath}/backoffice/merchant/location/product/list`,
        selectProductList:`${basePath}/backoffice/merchant/cart/item/list`,
        createCartProduct:`${basePath}/backoffice/merchant/cart/create`,
        createCartItem:`${basePath}/backoffice/merchant/cart/item/create`,
        deleteCartItem:`${basePath}/backoffice/merchant/cart/item/`,
        clearCartItem:`${basePath}/backoffice/merchant/cart/clear/`,
        holdCartItems:`${basePath}/backoffice/merchant/cart/`,
        getTotalAmount:`${basePath}/backoffice/merchant/order/calculate-amount/`,
        createOrder:`${basePath}/backoffice/merchant/order/create`,
        updateOrder:`${basePath}/backoffice/merchant/order/`,
        createReceipt:`${basePath}/backoffice/merchant/order/receipt/create`,
        orderReceiptList:`${basePath}/backoffice/merchant/order/receipt/list`,
        countryList:`${basePath}/country/list`
    },
    MerchantOrderlogUrls = {
        listlogs: `${basePath}/backoffice/merchant/order/log/list`,
        createLogs: `${basePath}/backoffice/merchant/order/create`,
        editUserCartItem:`${basePath}/backoffice/merchant/cart/item/`,
        orderList: `${basePath}/backoffice/merchant/order/list`,
        editOrder:`${basePath}/backoffice/merchant/order/`,
        deleteOrder:`${basePath}/backoffice/merchant/order/`,
        logOrder:`${basePath}/backoffice/merchant/order/log/list`

    },
    VouchersUrls={
     vouchersList:`${basePath}/voucher/active`,
     voucherValidate:`${basePath}/voucher/code/validate`,
     voucherRedeem:`${basePath}/voucher/code/redeem`,
     voucherRedeemedList:`${basePath}/voucher/code/list`,
    },
    userGuide = {
        list: `${basePath}/user/guide/list`,
    },
    NotificationUrls = {
        notificationList: `${basePath}/backoffice/user/notifications`,
    },
    MerchantTransactionUrls = {
        transactionList : `${basePath}/merchant/transaction/report/list`,
        summaryList : `${basePath}/merchant/transaction/summary/report`,
        businessModelList: `${basePath}/merchant/business-model/list`,
        codeList: `${basePath}/merchant/categorycode/list`,
    },
    rolesDetailUrls = {
        roleDetails: `${basePath}/backoffice/role-details`
    };

